module.exports = __webpack_public_path__ + "components/carousel-resort-picks/static/generic-bg--3-432f8674a19a3dfcfe872e8ef18c0527.jpg";